module.exports = __webpack_public_path__ + "static/img/mImg.ad7213bd.png";